import 'reflect-metadata';
const CACHE_KEY = "hola_fingerprint_result";
export class AnalizeFingerprint {
    async handle(fingerprint) {
        // Check sessionStorage cache (session-scoped, no TTL)
        try {
            const cached = sessionStorage.getItem(CACHE_KEY);
            if (cached) {
                return JSON.parse(cached);
            }
        }
        catch (_a) {
            // sessionStorage unavailable or parse error — proceed to POST
        }
        const apiUrl = process.env.REACT_APP_API_URL;
        const url = new URL(`/fingerprint`, apiUrl);
        const response = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(fingerprint)
        });
        const data = await response.json();
        // Store in sessionStorage (session-scoped, no TTL)
        try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
        }
        catch (_b) {
            // sessionStorage full or unavailable
        }
        return data;
    }
}
